// extracted by mini-css-extract-plugin
export default {"footer":"PreviewDealsListModel_footer__W5BoM"};